import { render } from "./IconTheme.vue?vue&type=template&id=5759d8fd"
import script from "./IconTheme.vue?vue&type=script&lang=js"
export * from "./IconTheme.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__